var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #Edit .cls-1{fill:#c5d75d}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1119.292 -199.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2300",
    d: "M1129.3 202.851a.36.36 0 0 0-.248-.111.222.222 0 0 0-.162.063l-5.084 5.083a.214.214 0 0 0-.055.1l-.2.633-.3.952a.366.366 0 0 0 .406.414l.968-.292.637-.192a.212.212 0 0 0 .108-.057l5.081-5.081a.3.3 0 0 0-.048-.41zm-4.3 6.072l-.2.059-.537-.536.059-.186 4.744-4.744.668.668z",
    className: "cls-1",
    transform: "translate(-1.458 -1.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2301",
    d: "M1125.292 199.15a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6zm0 11.368a5.368 5.368 0 1 1 5.368-5.368 5.374 5.374 0 0 1-5.368 5.368z",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f32b90b4583e9b9cacc119afb42549fe.svg";
export { ForwardRef as ReactComponent };